import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import { useEffect, useState } from "react";
import { Form, Button, Col, Row, Breadcrumb } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import ApiConection from "api_ref/ApiConection";
import { ConvertDateTimeToText } from "components/MyControl";

export default function ConfigAppDetail() {
    const api = new ApiConection();
    const navigate = useNavigate();

    const { id } = useParams();
    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState('view');
    const [initialData, setInitialData] = useState({});
    const [simulate, setSimulate] = useState({});

    const getData = async () => {
        const response = await api.getData(`api/ConfigApp/${id}`);
        if (response.status === true) {
            setSimulate(response.data);
            setInitialData(response.data);
        }
    }

    useEffect(() => {
        getData();
    }, [])

    const handleBreadcrumbClick = (e) => {
        navigate('/setting/config-app');
    };

    const handleSetSimulate = async (event) => {
        const { name, value, checked } = event.target;

        setSimulate(preData => { return { ...preData, [name]: value } });
    }

    const handleCancel = (event) => {
        setSimulate(initialData)
        setMode('view')
    }

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }

        let data = {
            name: simulate.name,
            value: simulate.value,
            data_type: simulate.data_type,
            description: simulate.description
        }

        const response = await api.putData(`api/ConfigApp/${id}`, data);

        if (response.status === true) {
            await getData();
            setMode('view');
        } else {
            setAlert(response.message);
            setMode('edit');
        }

        setLoading(false);
    }
    return (
        <Layout4Admin1 >
            <div className={Css.Block_Transparent}>
                <div className='contrainermt-3 mb-3'>
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={handleBreadcrumbClick}>ตั้งค่าแอพพลิเคชั่น</Breadcrumb.Item>
                        <Breadcrumb.Item active>
                            {
                                mode === 'view' ? 'ข้อมูลตัวแปร' :'แก้ไขตัวแปร'
                            }
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <Form noValidate validated={validated} onSubmit={event => handleSubmit(event)} >
                        <div className={`border rounded p-4 bg-white shadow w-100`}>
                            <div>
                                <Row>
                                    <Col>
                                        <h5 className='text-start mb-0'>
                                            ข้อมูลตัวแปร
                                        </h5>
                                        <Form.Text className="mb-5">ข้อมูลตัวแปรต่างๆ ที่ระบบ หรือโปรแกรมใช้งาน เมื่อทำการบันทึก จะมีผลกับระบบทันที</Form.Text>
                                    </Col>
                                    <Col className='text-end'>
                                        {
                                            mode === 'view' &&
                                            <Button variant="outline-secondary" type="button" className=''
                                                onClick={event => setMode('edit')}>
                                                แก้ไข
                                                <i className="ms-2 fa-solid fa-pencil"></i>
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            </div>
                            <div className="mt-5">
                                <Row className='mb-5'>
                                    <Col className='me-3'>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ชื่อต้วแปร</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'name'}
                                                value={simulate?.name}
                                                onChange={handleSetSimulate}
                                                placeholder="ชื่อต้วแปร" required={true} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ค่าตัวแปร</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'value'}
                                                value={simulate?.value}
                                                onChange={handleSetSimulate}
                                                placeholder="ชื่อต้วแปร" required={true} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ประเภท</Form.Label>
                                            {
                                                mode === 'view' &&
                                                <Form.Label className='d-block pt-2 pb-1 '>{simulate?.data_type}</Form.Label>
                                            }
                                            {
                                                mode === 'edit' &&
                                                <Form.Select name={'data_type'}
                                                    value={simulate?.data_type}
                                                    required={true}
                                                    placeholder="0000000000000"
                                                    onChange={handleSetSimulate} >
                                                    <option value={'string'}>string</option>
                                                    <option value={'int'}>int</option>
                                                    <option value={'bool'}>bool</option>
                                                </Form.Select>
                                            }
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>รายละเอียด</Form.Label>
                                            {
                                                mode === 'view' &&
                                                <Col>
                                                    <Form.Label className='d-block pt-2 pb-1'>{simulate?.description}</Form.Label>
                                                </Col>
                                            }
                                            {
                                                mode === 'edit' &&
                                                <Form.Control type={'text'}
                                                    plaintext={(mode === 'view') ? true : false}
                                                    readOnly={(mode === 'view') ? true : false}
                                                    className=''
                                                    name={'description'}
                                                    value={simulate?.description}
                                                    onChange={handleSetSimulate}
                                                    placeholder="รายละเอียด"
                                                    as="textarea" rows={3} />
                                            }
                                        </Form.Group>
                                    </Col>
                                    <Col className="me-3">
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="label-title">ผู้บันทึก</Form.Label>
                                            <Form.Label>{simulate?.modify_by}&nbsp;</Form.Label>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="label-title">วันที่บันทึกล่าสุด</Form.Label>
                                            <Form.Label>{ConvertDateTimeToText(simulate?.modify_date)}</Form.Label>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>
                            {
                                alert != '' &&
                                <div className="alert alert-danger" role="alert">
                                    {alert}
                                </div>
                            }

                            {
                                mode === 'edit' &&
                                <Row>
                                    <Col>
                                        <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                            onClick={event => handleCancel(event)}  >ยกเลิก</Button>
                                        <Button variant="primary" type="submit" className='ps-5 pe-5'
                                            disabled={loading}
                                        >บันทึก
                                            {
                                                loading === true &&
                                                <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            }
                                        </Button>
                                    </Col>
                                </Row>
                            }
                        </div>
                    </Form>
                </div>
            </div>
        </Layout4Admin1>
    )
}